// Frontend-only settings, stored as the JSON string in HedgePlanModel.configuration. The backend never
// reads it; anything backend logic needs belongs on HedgePlanModel as a regular field instead.
export interface HedgePlanConfiguration {
  enableValueTriggers: boolean;
  enableBudgetTriggers: boolean;
  enableTimeTriggers: boolean;
  chartSettings: HedgePlanChartSettings;
}

export interface HedgePlanChartSettings {
  showTimeTriggers: boolean;
  snapTradesToMarketPrice: boolean;
}


// Spread underneath a parsed configuration so plans saved before a field existed still get a value for it.
export const DefaultHedgePlanConfiguration: HedgePlanConfiguration = {
  enableValueTriggers: true,
  enableBudgetTriggers: true,
  enableTimeTriggers: true,
  chartSettings: {
    showTimeTriggers: true,
    snapTradesToMarketPrice: false,
  },
};
